'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialYahoo = function IoSocialYahoo(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.1 5.3c0.8 0 1.6-0.1 2.4-0.3l-10 16.6v13.4c-0.8-0.3-1.6-0.3-2.5-0.3s-1.7 0-2.5 0.3v-13.4l-10-16.6c0.8 0.3 1.6 0.3 2.5 0.3s1.7 0 2.5-0.3l7.5 12.5 7.5-12.5c0.8 0.3 1.7 0.3 2.6 0.3z' })
        )
    );
};

exports.default = IoSocialYahoo;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-yahoo.js
// module id = 2520
// module chunks = 0